import styled, { css } from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const OpacityWrapper = styled.div``

export const ProductInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  user-select: none;
`

const getCursorStyle = (disabled?: boolean, selectable?: boolean) => {
  if (disabled) return 'not-allowed'
  if (selectable) return 'pointer'

  return 'default'
}

export const Container = styled.div<{
  disabled?: boolean
  active?: boolean
  selectable?: boolean
}>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: ${({ disabled, selectable }) => getCursorStyle(disabled, selectable)};
  margin: -16px 0;
  padding: 16px 0;

  * {
    cursor: inherit;
    user-select: none;
  }

  ${mediaQueries.tablet} {
    gap: 20px;
    padding: 8px 0;
  }

  ${mediaQueries.laptop} {
    margin: -12px 0;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      ${OpacityWrapper} {
        opacity: 0.6;
      }
    `}

  ${({ active, disabled, selectable }) =>
    active &&
    !disabled &&
    selectable &&
    css`
      background-image: linear-gradient(
        90deg,
        ${Colors.GS100},
        ${Colors.GS200} 44.27%,
        ${Colors.GS200} 54.17%,
        ${Colors.GS100}
      );
    `}

  ${({ disabled, selectable }) =>
    !disabled &&
    selectable &&
    css`
      &:hover {
        background-image: linear-gradient(
          270deg,
          transparent,
          ${Colors.GS200} 25%,
          ${Colors.GS200} 71%,
          transparent
        );
      }
    `}
`

export const Label = styled.label`
  display: contents;
`
